export default __webpack_public_path__ + "static/child-comfort-a8ad38d5bfc8724fde3aedd16e2cdd0e.png";